const VERSION = 4;
export const CHAIN = 'sid';
// export const STATISTICS_API = 'http://localhost:3004';
export const STATISTICS_API = 'https://devjs-01.corp.aira.life:3005';
export const FACTORY = {
  name: 'factory.' + VERSION + '.robonomics.sid',
  address: '0xB12255b705dAe406D142c19787aA77859FECe0c6'
};
export const XRT = {
  name: 'xrt.' + VERSION + '.robonomics.sid',
  address: '0x093ac06910f23570292fd5027a4fA558ed4Cd010'
};
export const NET_TOPICS = ['graph.' + VERSION + '.robonomics.sid'];
export const ENS = '0xd89c3ba0dc0668efca15e54554436adc7b711160';
